
import "react-app-polyfill/ie11"
import "react-app-polyfill/stable"
import React from "react";
import ReactDOM from 'react-dom/client';
import App from './App'
import * as serviceWorker from './serviceWorker';
import reportWebVitals from "./reportWebVitals"
// Put any other imports below so that CSS from your
// components takes precedence over default styles.

// const customHistory = createBrowserHistory();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
